import {
  Button, Radio, Select, Skeleton, SelectField,
  IconLoading,
  IconCheckBg,
  IconError,
  IconArrow,
} from 'gatorcomponents';
import React, { useCallback, useEffect, useState } from 'react';
import * as Styles from './SupportForms.styles';
import useLocale from '@/hooks/useLocale/useLocale';
import { useSupportForms } from '@/hooks/supportForms';
import { useHistory } from 'react-router';
import { InternalMigration } from './components/InternalMigration/InternalMigration';
import { UserBackupRestore } from './components/UserBackupRestore/UserBackupRestore';
import { GenerateBackup } from './components/GenerateBackup/GenerateBackup';
import { HgProducts } from './SupportForms.types';
import { useDispatch, useSelector } from 'react-redux';
import { formsActions } from '@/redux/modules';
import { RestorateBackupHgRoutine } from './components/RestorateBackupHgRoutine';
import { WithoutEmailAccess } from './components/WithoutEmailAccess';
import { ChangePrimaryDomain } from './components/ChangePrimaryDomain';
import { ExternalMigration } from './components/ExternalMigration';
import { ChangeDueDate } from './components/ChangeDueDate';
import { GoogleAdwordsCoupon } from './components/GoogleAdwordsCoupon';
import { InstallExternalSsl } from './components/InstallExternalSsl';
import { FinancialDoubts } from './components/GeneralDoubts';
import { RestorateCancelledPlan } from './components/RestorateCancelledPlan';
import { GenerateCSR } from './components/GenerateCSR';
import { RestorateSiteBuilderAccess } from './components/RestorateSiteBuilderAccess';
import { AffiliateProgram } from './components/AffiliateProgram';
import { NationalDomainTransfer } from './components/NationalDomainTransfer';
import { UpgradeVps } from './components/UpgradeVps';
import { UpgradeVpsOci } from './components/UpgradeVpsOci';
import { ChangePlanVpsOci } from './components/ChangePlanVpsOci';
import { V2Forms } from '@/hooks/supportForms/useSupportForms.types';
import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { NEW_SUPPORT } from '@/config/GrowthBook/constants';
import { COUNTRY, IS_PROD } from '@/config';
import { SiteLockUpgrade } from './components/SiteLockUpgrade';
import { CodeGuardUpgrade } from './components/CodeGuardUpgrade';
import { GatorBackupUpgrade } from './components/GatorBackupUpgrade';
import { ChangePaymentcycle } from './components/ChangePaymentcycle';
import { PrivateSslCertificate } from './components/PrivateSslCertificate';
import { WildcardSslCertificate } from './components/WildcardSslCertificate';
import { EnterpriseSslCertificate } from './components/EnterpriseSslCertificate';
import { InstallWhmcs } from './components/InstallWhmcs';
import { ReloadRebuild } from './components/ReloadRebuild';
import { ReloadRebuildVpsOci } from './components/ReloadRebuildVpsOci';
import { MoreEmails } from './components/MoreEmails';
import { MigrateVpsDedicated } from './components/MigrateVpsDedicated';
import { MigrateAccountVpsDedicated } from './components/MigrateAccountVpsDedicated';
import { UpdateWhmcsLicense } from './components/UpdateWhmcsLicense';
import { WhmcsAcquisition } from './components/WhmcsAcquisition';
import { UpgradeSitebuilder } from './components/UpgradeSitebuilder';
import { MigrateResellerBr } from './components/MigrateResellerBr';
import { isBRServer } from '@/utils/Validators/validation';
import { MigrateResellerEs } from './components/MigrateResellerEs';
import CommonForm from './components/CommonForm';
import { SslEv } from './components/SslEv';

const SupportForms = ({
  serviceType = {
    onSuccess: null,
    onBackForm: null,
    lockedOptions: false,
    title: '',
    defaultValues: {},
  },

}) => {
  const { ticket: ticketsLocale, routes: routesLocale } = useLocale();
  const history = useHistory();
  const dispatch = useDispatch();
  const [showFeedback, setShowFeedback] = useState();
  const [opening, setOpening] = useState(false);
  const [formData, setFormData] = useState();
  const clientInfo = useSelector(state => state.summary);
  const useNewSupport = useFeatureIsOn(NEW_SUPPORT);
  const { ticketType } = useSelector(state => state.preChat);
  const [isAutomated, setIsAutomated] = useState(false);

  const {
    forceState, rules,
  } = useSelector(state => state.formsReducer);

  const {
    requestForms,
    productsOptions,
    loading,
    checkProduct,
    selectedProductOption,
    selectedProduct,
    checkNeed,
    checkSector,
    handleSelectedProductOption,
    setSelectedSector,
    selectedSector,
    selectedNeed,
    needsOptions,
    setSelectedNeed,
    activeProductsOptions,
    setSelectedProductData,
    requestedProducts,
    selectedProductData,
  } = useSupportForms({
    ...serviceType.defaultValues,
    forceState,
    rules,
  });

  const setForcedState = useCallback(() => {
    if (
      forceState
      && handleSelectedProductOption
      && productsOptions.length
      && rules
      && rules.active
    ) {
      const ruleProduct = rules.selectedProduct || rules.active;
      const selectedOption = productsOptions.find((option) => {
        if (ruleProduct.id) {
          return option.value === ruleProduct.id;
        }
        return option.label === ruleProduct;
      });
      const fullSelectedProductData = requestedProducts.find(product => product.id === ruleProduct.id);

      setSelectedProductData(fullSelectedProductData);
      if (selectedOption) {
        handleSelectedProductOption(selectedOption.label);
      }
      setSelectedSector(rules.selectedSector);
      setTimeout(() => {
        setSelectedNeed(rules.selectedNeed);
      }, 100);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    forceState,
    rules,
    rules.active,
    rules.restorateBackupHgRoutine,
    setSelectedSector,
    handleSelectedProductOption,
    productsOptions,
    setSelectedProductData,
    setSelectedNeed,
    requestedProducts,
  ]);

  useEffect(() => {
    setForcedState();
  }, [setForcedState]);

  const clearForcedState = useCallback(() => {
    dispatch(formsActions.forceState.clear());
  }, [dispatch]);

  useEffect(() => () => {
    clearForcedState();
  }, [clearForcedState]);

  useEffect(() => {
    requestForms(ticketType);
    setShowFeedback(undefined);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ticketType]);

  useEffect(() => {
    checkProduct();
  }, [checkProduct]);

  useEffect(() => {
    checkSector();
  }, [checkSector]);

  useEffect(() => {
    checkNeed();
  }, [checkNeed]);

  const addNewZendeskData = useCallback((data) => {
    const newData = { ...data };
    if (selectedSector === 'technical') {
      newData.domain_id = '27835972869267';
      newData.server_id = '27836218257939';
      newData.plan_id = '28285611660947';
    }

    if (selectedSector !== 'technical') {
      newData.domain_id = '27835972869267';
      newData.server_id = '28285611660947';
    }

    newData.server_value = selectedProductData ? selectedProductData.serverhostname : '';
    newData.domain_value = selectedProductData ? selectedProductData.domain : '';
    newData.plan_value = selectedProductData ? selectedProductData.name : '';

    switch (data.key) {
      case V2Forms.INTERNAL_MIGRATION:
        newData.group_id = '27293098116243';
        newData.category_id = '28251033477139';
        newData.category_value = 'hg_migracao';
        newData.sub_category_id = '28254219203219';
        newData.sub_category_value = 'hg_migracao_interna_cliente_existente';
        break;
      case V2Forms.EXTERNAL_MIGRATION:
        newData.group_id = '27293098116243';
        newData.category_id = '28251033477139';
        newData.category_value = 'hg_migracao';
        newData.sub_category_id = '28254219203219';
        newData.sub_category_value = 'hg_migracao_externa_novo_cliente';
        break;
      case V2Forms.USER_BACKUP_RESTORE:
        newData.group_id = '27292926799507';
        newData.category_id = '28251033477139';
        newData.category_value = 'hg_restauracao_de_backup';
        newData.sub_category_id = '28253974154131';
        newData.sub_category_value = 'hg_restauracao_de_backup';
        break;
      case V2Forms.GENERATE_BACKUP:
        newData.group_id = '27292918946835';
        newData.category_id = '28251033477139';
        newData.category_value = 'hg_restauracao_de_backup';
        newData.sub_category_id = '28253974154131';
        newData.sub_category_value = 'hg_restauracao_de_backup';
        break;
      case V2Forms.RESTORATE_HG_ROUTINE:
        newData.group_id = '27292926799507';
        newData.category_id = '28251033477139';
        newData.category_value = 'hg_restauracao_de_backup';
        newData.sub_category_id = '28253974154131';
        newData.sub_category_value = 'hg_restauracao_de_backup';
        break;
      case V2Forms.WITHOUT_EMAIL_ACCESS:
        newData.group_id = '27293010048019';
        newData.category_id = '28250390746387';
        newData.category_value = 'hg_recuperacao_de_acesso_e-mail';
        newData.sub_category_id = '';
        newData.sub_category_value = '';
        break;
      case V2Forms.CHANGE_PRIMARY_DOMAIN:
        newData.group_id = '23450116897811';
        newData.category_id = '28251033477139';
        newData.category_value = 'hg_alteracao_dominio_primario';
        newData.sub_category_id = '';
        newData.sub_category_value = '';
        break;
      case V2Forms.CHANGE_DUE_DATE:
        newData.group_id = '27293010048019';
        newData.category_id = '28250390746387';
        newData.category_value = 'hg_alteracao_data_de_vencimento';
        newData.sub_category_id = '';
        newData.sub_category_value = '';
        break;
      case V2Forms.GOOGLE_ADWORDS_COUPON:
        newData.group_id = '23450116897811';
        newData.category_id = '28251033477139';
        newData.category_value = 'hg_google_adwords';
        newData.sub_category_id = '';
        newData.sub_category_value = '';
        break;
      case V2Forms.EXTERNAL_SSL:
        newData.group_id = '23450116897811';
        newData.category_id = '28251033477139';
        newData.category_value = 'hg_instalacao_de_ssl';
        newData.sub_category_id = '28254262891667';
        newData.sub_category_value = 'hg_instalacao_de_ssl';
        break;
      case V2Forms.FINANCIAL_DOUBTS:
        newData.group_id = '27293010048019';
        newData.category_id = '28250390746387';
        newData.category_value = 'hg_outros_financeiro';
        newData.sub_category_id = '';
        newData.sub_category_value = '';
        break;
      case V2Forms.RESTORATE_CANCELLED_PLAN:
        newData.group_id = '27292926799507';
        newData.category_id = '28251033477139';
        newData.category_value = 'hg_restauracao_de_backup';
        newData.sub_category_id = '28253974154131';
        newData.sub_category_value = 'hg_restauracao_de_backup';
        break;
      case V2Forms.GENERATE_CSR:
        newData.group_id = '23450116897811';
        newData.category_id = '28251033477139';
        newData.category_value = 'hg_instalacao_de_ssl';
        newData.sub_category_id = '28254262891667';
        newData.sub_category_value = 'hg_csr_ssl';
        break;
      case V2Forms.RESTORATE_SITEBUILDER_ACCESS:
        newData.group_id = '23450116897812';
        newData.category_id = '28251033477139';
        newData.category_value = 'hg_restauracao_de_backup';
        newData.sub_category_id = '28253974154131';
        newData.sub_category_value = 'hg_restauracao_acesso_criador_de_sites';
        break;
      case V2Forms.AFFILIATE_PROGRAM:
        newData.group_id = '27292861425427';
        newData.category_id = '28251033477139';
        newData.category_value = 'hg_afiliados';
        newData.sub_category_id = '';
        newData.sub_category_value = '';
        break;
      case V2Forms.NATIONAL_DOMAIN_TRANSFER:
        newData.group_id = '27911666087059';
        newData.category_id = '28251033477139';
        newData.category_value = 'hg_dominios';
        newData.sub_category_id = '29794347165715';
        newData.sub_category_value = 'hg_dominios_transferencia_de_dominio_nacional';
        break;
      case V2Forms.UPGRADE_VPS:
        newData.group_id = '27293010048019';
        newData.category_id = '28250390746387';
        newData.category_value = 'hg_upgrade/downgrade';
        newData.sub_category_id = '';
        newData.sub_category_value = '';
        break;
      case V2Forms.UPGRADE_VPS_OCI:
        newData.group_id = '27293010048019';
        newData.category_id = '28250390746387';
        newData.category_value = 'hg_upgrade/downgrade';
        newData.sub_category_id = '';
        newData.sub_category_value = '';
        break;
      case V2Forms.CHANGEPLAN_VPS_OCI:
        newData.group_id = '27292955547155';
        newData.category_id = '42014880645395';
        newData.category_value = 'hg_avancado_categoria_vps_oci_alteracao_de_plano';
        newData.sub_category_id = '';
        newData.sub_category_value = '';
        break;
      case V2Forms.UPGRADE_SITELOCK:
        newData.group_id = '27293010048019';
        newData.category_id = '28250390746387';
        newData.category_value = 'hg_upgrade/downgrade';
        newData.sub_category_id = '';
        newData.sub_category_value = '';
        break;
      case V2Forms.UPGRADE_CODEGUARD:
        newData.group_id = '27293010048019';
        newData.category_id = '28250390746387';
        newData.category_value = 'hg_upgrade/downgrade';
        newData.sub_category_id = '';
        newData.sub_category_value = '';
        break;
      case V2Forms.UPGRADE_GATOR_BACKUP:
        newData.group_id = '27293010048019';
        newData.category_id = '28250390746387';
        newData.category_value = 'hg_upgrade/downgrade';
        newData.sub_category_id = '';
        newData.sub_category_value = '';
        break;
      case V2Forms.CHANGE_DUE_DATE3:
        newData.group_id = '27293010048019';
        newData.category_id = '28250390746387';
        newData.category_value = 'hg_alteracao_data_de_vencimento';
        newData.sub_category_id = '';
        newData.sub_category_value = '';
        break;
      case V2Forms.CHANGE_PAYMENT_CYCLE:
        newData.group_id = '27293010048019';
        newData.category_id = '28250390746387';
        newData.category_value = 'hg_alteracao_ciclo_de_pagamento';
        newData.sub_category_id = '';
        newData.sub_category_value = '';
        break;
      case V2Forms.PRIVATE_SSL:
        newData.group_id = '23450116897811';
        newData.category_id = '28251033477139';
        newData.category_value = 'hg_instalacao_de_ssl';
        newData.sub_category_id = '28254262891667';
        newData.sub_category_value = 'hg_instalacao_de_ssl';
        break;
      case V2Forms.WILDCARD_SSL:
        newData.group_id = '23450116897811';
        newData.category_id = '28251033477139';
        newData.category_value = 'hg_instalacao_de_ssl';
        newData.sub_category_id = '28254262891667';
        newData.sub_category_value = 'hg_instalacao_de_ssl';
        break;
      case V2Forms.ENTERPRISE_SSL:
        newData.group_id = '23450116897811';
        newData.category_id = '28251033477139';
        newData.category_value = 'hg_instalacao_de_ssl';
        newData.sub_category_id = '28254262891667';
        newData.sub_category_value = 'hg_instalacao_de_ssl';
        break;
      case V2Forms.INSTALL_WHMCS:
        newData.group_id = '27292955547155';
        newData.category_id = '28251033477139';
        newData.category_value = 'hg_whmcs';
        newData.sub_category_id = '28254313912211';
        newData.sub_category_value = 'hg_outros_whmcs';
        break;
      case V2Forms.RELOAD_REBUILD:
        newData.group_id = '27292955547155';
        newData.category_id = '28251033477139';
        newData.category_value = 'hg_reload_rebuild';
        newData.sub_category_id = '';
        newData.sub_category_value = '';
        break;
      case V2Forms.RELOAD_REBUILD_VPS_OCI:
        newData.group_id = '27292955547155';
        newData.category_id = '28251033477139';
        newData.category_value = 'hg_reload_rebuild';
        newData.sub_category_id = '';
        newData.sub_category_value = '';
        break;
      case V2Forms.MIGRATE_VPS_DEDICATED:
        newData.group_id = '27293098116243';
        newData.category_id = '28251033477139';
        newData.category_value = 'hg_migracao';
        newData.sub_category_id = '28254219203219';
        newData.sub_category_value = 'hg_migracao_vps_dedicado';
        break;
      case V2Forms.MIGRATE_ACCOUNT_VPS_DEDICATED:
        newData.group_id = '27293098116243';
        newData.category_id = '28251033477139';
        newData.category_value = 'hg_migracao';
        newData.sub_category_id = '28254219203219';
        newData.sub_category_value = 'hg_migracao_vps_dedicado';
        break;
      case V2Forms.UPDATE_WHMCS_LICENSE:
        newData.group_id = '27292955547155';
        newData.category_id = '28251033477139';
        newData.category_value = 'hg_whmcs';
        newData.sub_category_id = '28254313912211';
        newData.sub_category_value = 'hg_solicitar_licenca';
        break;
      case V2Forms.WHMCS_ACQUISITION:
        newData.group_id = '27292955547155';
        newData.category_id = '28251033477139';
        newData.category_value = 'hg_whmcs';
        newData.sub_category_id = '28254313912211';
        newData.sub_category_value = 'hg_solicitar_licenca';
        break;
      case V2Forms.MIGRATE_RESELLER:
        newData.group_id = '27293098116243';
        newData.category_id = '28251033477139';
        newData.category_value = 'hg_migracao';
        newData.sub_category_id = '28254219203219';
        newData.sub_category_value = 'hg_migracao_revenda';
        break;
      case V2Forms.SSL_EV:
        newData.group_id = '23450116897811';
        newData.category_id = '28251033477139';
        newData.category_value = 'hg_ssl';
        newData.sub_category_id = '28254262891667';
        newData.sub_category_value = 'hg_instalacao_de_ssl';
        break;
      case V2Forms.UPGRADE_SITEBUILDER:
        newData.group_id = '27293010048019';
        newData.category_id = '28250390746387';
        newData.category_value = 'hg_upgrade/downgrade';
        newData.sub_category_id = '';
        newData.sub_category_value = '';
        break;
      default:
        break;
    }

    if (!IS_PROD) {
      newData.group_id = '24966089236755';
    }

    return newData;
  }, [selectedSector, selectedProductData]);

  const onSuccessCustomHandler = useCallback(() => {
    if (serviceType && serviceType.onSuccess) {
      serviceType.onSuccess();
    }
  }, [serviceType]);

  const submitForm = useCallback((data, sendRawData) => {
    setIsAutomated(false);
    setOpening(true);

    const dataObject = {
      ...data,
      tags: [
        ...(data.tags || []),
        COUNTRY,
      ],
    };

    if (clientInfo.isFromAffiliated) {
      dataObject.tags.push('atendimento_prioritario_afiliado');
    }

    const hasSuperGatorActive = activeProductsOptions && activeProductsOptions.some(product => product.pid === HgProducts.SUPERGATOR);

    if (hasSuperGatorActive) {
      dataObject.tags.push('supergator');
    }

    const newData = !sendRawData ? addNewZendeskData(dataObject) : dataObject;

    if (!formData) {
      setFormData(dataObject);
    }

    const onSuccess = () => {
      setIsAutomated({
        name: data.automation,
        automationRedirect: data.automationRedirect,
      });
      setOpening(false);
      setShowFeedback('success');
      setFormData(undefined);

      onSuccessCustomHandler();
    };

    const onFail = () => {
      setOpening(false);
      setShowFeedback('fail');
    };

    newData.onSuccess = onSuccess;
    newData.onFail = onFail;
    dispatch(formsActions.send.request({ data: newData }));
  }, [dispatch, addNewZendeskData, formData, activeProductsOptions, onSuccessCustomHandler]);

  const tryCreateFormAgain = useCallback(() => {
    setShowFeedback(undefined);
    submitForm(formData, true);
  }, [formData, submitForm]);


  const getInternalMigrationProps = useCallback(() => {
    let destinationProductsOptions = [];

    if (activeProductsOptions) {
      destinationProductsOptions = [...activeProductsOptions].map((product) => {
        const newProduct = { ...product };
        newProduct.label = `${newProduct.name} - ${newProduct.domain}`;
        return newProduct;
      });

      destinationProductsOptions = [...destinationProductsOptions].filter((product) => {
        const isHosting = HgProducts.HOSTING_ALL.includes(product.pid);
        return product.label !== selectedProductOption && isHosting;
      });
    }

    const defaultProps = {
      selectedProduct,
      selectedProductOption,
      destinationProductsOptions,
      submitForm: e => submitForm(e),
      opening,
    };

    return defaultProps;
  }, [selectedProduct, activeProductsOptions, selectedProductOption, submitForm, opening]);

  const getUserBackupRestoreProps = useCallback(() => {
    let destinationProductsOptions = [];

    if (activeProductsOptions) {
      destinationProductsOptions = [...activeProductsOptions].map((product) => {
        const newProduct = { ...product };
        newProduct.label = `${newProduct.name} - ${newProduct.domain}`;
        return newProduct;
      });

      destinationProductsOptions = [...destinationProductsOptions].filter((product) => {
        const isHosting = HgProducts.HOSTING_ALL.includes(product.pid);
        return product.label !== selectedProductOption && isHosting;
      });
    }

    const defaultProps = {
      selectedProduct,
      selectedProductOption,
      destinationProductsOptions,
      submitForm: e => submitForm(e),
      opening,
    };

    return defaultProps;
  }, [selectedProduct, activeProductsOptions, selectedProductOption, submitForm, opening]);

  const getWithoutEmailAccess = useCallback(() => {
    const defaultProps = {
      submitForm: e => submitForm(e),
      email: clientInfo && clientInfo.email,
      document: clientInfo && clientInfo.document,
      opening,
    };

    return defaultProps;
  }, [
    submitForm,
    clientInfo,
    opening,
  ]);

  const getGenerateCSRProps = useCallback(() => {
    const customerSummary = {
      name: clientInfo.name,
      email: clientInfo.email,
      city: clientInfo.city,
      state: clientInfo.state,
      country: clientInfo.country,
      company: clientInfo.companyname,
    };

    const defaultProps = {
      submitForm: e => submitForm(e),
      selectedProduct,
      customerSummary,
      opening,
    };

    return defaultProps;
  }, [selectedProduct, clientInfo, opening, submitForm]);

  const getNationalDomainTransferProps = useCallback(() => {
    const defaultProps = {
      submitForm,
      opening,
    };

    return {
      ...defaultProps,
    };
  }, [submitForm, opening]);

  const getDefaultFormProps = useCallback((ticketType) => {
    const defaultProps = {
      submitForm,
      selectedProduct,
      opening,
      selectedProductOption,
      ticketType,
    };

    return {
      ...defaultProps,
    };
  }, [
    submitForm,
    selectedProduct,
    opening,
    selectedProductOption,
  ]);

  if (loading) {
    return (
      <Styles.PageContainer data-testid="loaderContainer">
        <Styles.SkeletonWrapper data-testid="loader">
          <Skeleton variant="headline" width="380px" />
          <Skeleton variant="input" width="498px" />
        </Styles.SkeletonWrapper>
      </Styles.PageContainer>
    );
  }

  const renderForm = {
    [ticketsLocale.forms.names.internalMigration]: <InternalMigration {...getInternalMigrationProps()} />,
    [ticketsLocale.forms.names.userBackupRestore]: <UserBackupRestore {...getUserBackupRestoreProps()} />,
    [ticketsLocale.forms.names.restorateBackupHgRoutine]: <RestorateBackupHgRoutine {...getDefaultFormProps()} />,
    [ticketsLocale.forms.names.restorateCancelledPlan]: <RestorateCancelledPlan {...getDefaultFormProps()} />,
    [ticketsLocale.forms.names.generateBackup]: <GenerateBackup {...getDefaultFormProps()} />,
    [ticketsLocale.forms.names.withoutEmailAccess]: <WithoutEmailAccess {...getWithoutEmailAccess()} />,
    [ticketsLocale.forms.names.changePrimaryDomain]: <ChangePrimaryDomain {...getDefaultFormProps()} />,
    [ticketsLocale.forms.names.changeDueDate]: <ChangeDueDate {...getDefaultFormProps()} />,
    [ticketsLocale.forms.names.googleAdwordsCoupon]: <GoogleAdwordsCoupon {...getDefaultFormProps()} />,
    [ticketsLocale.forms.names.externalMigration]: <ExternalMigration {...getDefaultFormProps()} />,
    [ticketsLocale.forms.names.installExternalSsl]: <InstallExternalSsl {...getDefaultFormProps()} />,
    [ticketsLocale.forms.names.financialDoubts]: <FinancialDoubts {...getDefaultFormProps()} />,
    [ticketsLocale.forms.names.generateCSR]: <GenerateCSR {...getGenerateCSRProps()} />,
    [ticketsLocale.forms.names.restorateSiteBuilderAccess]: <RestorateSiteBuilderAccess {...getDefaultFormProps()} />,
    [ticketsLocale.forms.names.affiliateProgram]: <AffiliateProgram {...getDefaultFormProps()} />,
    [ticketsLocale.forms.names.nationalDomainTransfer]: <NationalDomainTransfer {...getNationalDomainTransferProps()} />,
    [ticketsLocale.forms.names.upgradeVps]: <UpgradeVps {...getDefaultFormProps()} />,
    [ticketsLocale.forms.names.upgradeVpsOci]: <UpgradeVpsOci {...getDefaultFormProps()} />,
    [ticketsLocale.forms.names.changePlanVpsOci]: <ChangePlanVpsOci {...getDefaultFormProps()} />,
    [ticketsLocale.forms.names.upgradeSiteLock]: <SiteLockUpgrade {...getDefaultFormProps()} />,
    [ticketsLocale.forms.names.upgradeCodeGuard]: <CodeGuardUpgrade {...getDefaultFormProps()} />,
    [ticketsLocale.forms.names.upgradeGatorBackup]: <GatorBackupUpgrade {...getDefaultFormProps()} />,
    [ticketsLocale.forms.names.upgradeSiteBuilder]: <UpgradeSitebuilder {...getDefaultFormProps()} />,
    [ticketsLocale.forms.names.ChangePaymentcycle]: <ChangePaymentcycle {...getDefaultFormProps()} />,
    [ticketsLocale.forms.names.privateSslCertificate]: <PrivateSslCertificate {...getDefaultFormProps()} />,
    [ticketsLocale.forms.names.widlcardSslCertificate]: <WildcardSslCertificate {...getDefaultFormProps()} />,
    [ticketsLocale.forms.names.enterPrisessslCertificate]: <EnterpriseSslCertificate {...getDefaultFormProps()} />,
    [ticketsLocale.forms.names.installWhmcs]: <InstallWhmcs {...getDefaultFormProps()} />,
    [ticketsLocale.forms.names.reloadRebuild]: <ReloadRebuild {...getDefaultFormProps()} />,
    [ticketsLocale.forms.names.reloadRebuildVpsOci]: <ReloadRebuildVpsOci {...getDefaultFormProps()} />,
    [ticketsLocale.forms.names.moreEmails]: <MoreEmails {...getDefaultFormProps()} />,
    [ticketsLocale.forms.names.migrateVpsDedicated]: <MigrateVpsDedicated {...getDefaultFormProps()} />,
    [ticketsLocale.forms.names.migrateAccountVpsDedicated]: <MigrateAccountVpsDedicated {...getDefaultFormProps()} />,
    [ticketsLocale.forms.names.updateWhmcsLicense]: <UpdateWhmcsLicense {...getDefaultFormProps()} />,
    [ticketsLocale.forms.names.whmcsAcquisition]: <WhmcsAcquisition {...getDefaultFormProps()} />,
    [ticketsLocale.forms.names.migrateReseller]: isBRServer
      ? <MigrateResellerBr {...getDefaultFormProps()} />
      : <MigrateResellerEs {...getDefaultFormProps()} />,
    [ticketsLocale.forms.names.sslEV]: <SslEv {...getDefaultFormProps()} />,
    [ticketsLocale.forms.names.financial]: <CommonForm {...getDefaultFormProps('financial')} />,
    [ticketsLocale.forms.names.hosting]: <CommonForm {...getDefaultFormProps('hosting')} />,
    [ticketsLocale.forms.names.domain]: <CommonForm {...getDefaultFormProps('domain')} />,
    [ticketsLocale.forms.names.email]: <CommonForm {...getDefaultFormProps('email')} />,
    [ticketsLocale.forms.names.siteOffline]: <CommonForm {...getDefaultFormProps('siteOffline')} />,
    [ticketsLocale.forms.names.other]: <CommonForm {...getDefaultFormProps('other')} />,
  };

  const isV3Form = [ticketsLocale.forms.names.hosting, ticketsLocale.forms.names.domain, ticketsLocale.forms.names.email, ticketsLocale.forms.names.siteOffline, ticketsLocale.forms.names.other].includes(selectedProductOption);

  const title = (serviceType && serviceType.title) || ticketsLocale.openNewTicketPage.title;
  const lockedOptions = serviceType && serviceType.lockedOptions;

  if (useNewSupport && opening) {
    return (
      <Styles.PageContainer data-testid="support-forms-page-container">
        <Styles.CreateTicketWrapper>
          <Styles.Feedback>
            <IconLoading size="xl" />
            <Styles.LoadingTicketText>{ticketsLocale.opening}</Styles.LoadingTicketText>
          </Styles.Feedback>
        </Styles.CreateTicketWrapper>
      </Styles.PageContainer>
    );
  }

  if (useNewSupport && showFeedback === 'success') {
    return (
      <Styles.PageContainer data-testid="support-forms-page-container">
        <Styles.CreateTicketWrapper>
          <Styles.Feedback>
            <IconCheckBg size="xl" secondaryColor="activePure" />
            <Styles.LoadingTicketTitle>
              {isAutomated
                && ticketsLocale.automated[isAutomated.name]
                && ticketsLocale.automated[isAutomated.name].title
                ? ticketsLocale.automated[isAutomated.name].title
                : ticketsLocale.openingSuccess
              }
            </Styles.LoadingTicketTitle>
            <Styles.LoadingTicketDescription>
              {isAutomated
                && ticketsLocale.automated[isAutomated.name]
                && ticketsLocale.automated[isAutomated.name].description
                ? ticketsLocale.automated[isAutomated.name].description
                : ticketsLocale.openingSuccessDescription
              }
            </Styles.LoadingTicketDescription>
            <Button
              size="large"
              label={isAutomated
                && ticketsLocale.automated[isAutomated.name]
                && ticketsLocale.automated[isAutomated.name].cta
                ? ticketsLocale.automated[isAutomated.name].cta
                : ticketsLocale.backToSupport
              }
              onClick={() => history.push(
                isAutomated
                  && isAutomated.automationRedirect
                  ? isAutomated.automationRedirect
                  : routesLocale.help,
              )}
            />
          </Styles.Feedback>
        </Styles.CreateTicketWrapper>
      </Styles.PageContainer>
    );
  }

  if (useNewSupport && showFeedback === 'fail') {
    return (
      <Styles.PageContainer data-testid="support-forms-page-container">
        <Styles.CreateTicketWrapper>
          <Styles.Feedback>
            <IconError size="xl" secondaryColor="problemLight" />
            <Styles.LoadingTicketTitle marginBottom maxWidth={300}>{ticketsLocale.openingError}</Styles.LoadingTicketTitle>
            <Button
              size="large"
              label={ticketsLocale.tryAgain}
              onClick={tryCreateFormAgain}
            />
          </Styles.Feedback>
        </Styles.CreateTicketWrapper>
      </Styles.PageContainer>
    );
  }

  return (
    <>
      <Styles.PageContainer data-testid="support-forms-page-container">
        <Styles.CreateTicketWrapper selectedProduct={!!selectedProduct}>
          <Styles.Title>
            {serviceType && serviceType.onBackForm && (
              <Styles.BackButton onClick={() => serviceType.onBackForm()}>
                <IconArrow
                  size="lg"
                  color="lowDark"
                  testId="vpsoci-product-templates-page-back-button-icon"
                  direction="left"
                />
              </Styles.BackButton>
            )}
            {title}
          </Styles.Title>
          <Styles.SelectProductWrapper disabled={lockedOptions}>
            {!ticketType && !isV3Form && (
            <Select
              label={selectedProductOption ? ticketsLocale.openNewTicketPage.selecteProductOptionPlaceholder : ''}
              placeholder={ticketsLocale.openNewTicketPage.selecteProductOptionPlaceholder}
              options={productsOptions}
              value={selectedProductOption}
              setValue={label => handleSelectedProductOption(label)}
              testId="selectProduct"
              withScroll
            />

            )}

            {(isV3Form || ticketType) && (
              <SelectField
                label={selectedProductOption ? ticketsLocale.openNewTicketPage.selecteProductOptionPlaceholder : ''}
                placeholder={ticketsLocale.openNewTicketPage.selecteProductOptionPlaceholder}
                options={productsOptions}
                value={selectedProductOption}
                setValue={label => handleSelectedProductOption(label)}
                testId="selectProduct"
                positionAbsolute
              />
            )}
          </Styles.SelectProductWrapper>

          {selectedProduct && (
            <Styles.RadioSection disabled={lockedOptions}>
              <Styles.Label>{ticketsLocale.openNewTicketPage.selecteSectorOptionPlaceholder}</Styles.Label>
              <Styles.RadioWrapper>
                <Styles.RadioLabel htmlFor="#billing" onClick={() => setSelectedSector('billing')} data-testid="billingRadio">
                  <Radio checked={selectedSector === 'billing'} id="billing" />
                  {ticketsLocale.openNewTicketPage.sectorBilling}
                </Styles.RadioLabel>

                {selectedProduct && selectedProduct.active && (
                  <Styles.RadioLabel htmlFor="#technical" onClick={() => setSelectedSector('technical')} data-testid="technicalRadio">
                    <Radio checked={selectedSector === 'technical'} id="technical" />
                    {ticketsLocale.openNewTicketPage.sectorTechnical}
                  </Styles.RadioLabel>
                )}
              </Styles.RadioWrapper>
            </Styles.RadioSection>
          )}

          {selectedSector && (
            <Styles.SelectNeedWrapper disabled={lockedOptions}>
              <Select
                label={selectedNeed ? ticketsLocale.openNewTicketPage.selecteNeedOptionPlaceholder : ''}
                placeholder={ticketsLocale.openNewTicketPage.selecteNeedOptionPlaceholder}
                options={needsOptions}
                value={selectedNeed}
                setValue={setSelectedNeed}
                withScroll
              />
            </Styles.SelectNeedWrapper>
          )}

          {renderForm[selectedNeed || selectedProductOption]}
        </Styles.CreateTicketWrapper>
      </Styles.PageContainer>
    </>
  );
};

export default SupportForms;
